import withPagesPropTypes from '../../../../../contexts/PagesContext/withPages.attachesPropTypes'

const SearchBoxPropTypes = {
  ...withPagesPropTypes
}

export default SearchBoxPropTypes
